export type SysAdminState = {
  selectedMenu: number | undefined;
};

export const initialSysAdminState: SysAdminState = {
  selectedMenu: undefined,
};

export enum SysAdminStoreActions {
  SelectMenu = '[Sys Admin] Select Menu',
}
